// InvoicePDF.jsx
import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";

// Invoice logo
import Logo from "../../images/reebuk-logo.jpg"; // Ensure this is a local import or a valid base64 image
import { formatToDayMonthYear, formatToFullDate } from "../../libs/const";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    padding: 20,
    lineHeight: 1.5,
    backgroundColor: "#f6f6f6",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  logo: {
    width: 150,
    height: 120,
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 10,
  },
  section: {
    marginBottom: 10,
  },
  table: {
    display: "table",
    width: "auto",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol1: {
    width: "70%",
    padding: 5,
    border: "1px solid #000",
  },
  tableCol2: {
    width: "30%",
    padding: 5,
    border: "1px solid #000",
    textAlign: "right",
  },
  bold: {
    fontWeight: "bold",
  },
});

const InvoicePDF = ({ detailsInfo, providerLicenseNo }) => {
  console.log("detailsInfo ===========>", detailsInfo);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image src={Logo} style={styles.logo} />
          <View style={{ textAlign: "right", width: "100%" }}>
            <Text style={[styles.title, { textAlign: "right" }]}>
              INVOICE FROM REEBUK
            </Text>
            <Text style={{ textAlign: "right" }}>Reebok Health Inc.</Text>
            <Text style={{ textAlign: "right" }}>
              3601 Hwy 7 E, Suite #1005
            </Text>
            <Text style={{ textAlign: "right" }}>Markham, Ontario L3R 0M3</Text>
            <Text style={{ textAlign: "right" }}>Canada</Text>
            <View style={{ marginTop: "10px", textAlign: "right" }}>
              <Text style={{ textAlign: "right" }}>Phone: 416-848-7032</Text>
              <Text style={{ textAlign: "right" }}>Fax: 905-272-5951</Text>
              <Text style={{ textAlign: "right" }}>www.reebukhealth.com</Text>
            </View>
          </View>
        </View>

        <View
          style={[
            styles.section,
            { borderTop: "1px solid #000", paddingTop: "20px" },
          ]}
        >
          <Text>Patient Name:{detailsInfo?.patient_details?.full_name}</Text>
          <Text>
            Appointment Date: {formatToDayMonthYear(detailsInfo?.date)},{" "}
            {detailsInfo?.time}
          </Text>
          <Text>Appointment Location: {detailsInfo?.service_address}</Text>
        </View>

        <View style={styles.table}>
          <View
            style={[
              styles.tableRow,
              { backgroundColor: "#000", color: "#fff" },
            ]}
          >
            <Text
              style={[
                styles.tableCol1,
                styles.bold,
                { borderRightColor: "#fff" },
              ]}
            >
              Item Description
            </Text>
            <Text
              style={[
                styles.tableCol2,
                styles.bold,
                { borderLeftColor: "#fff" },
              ]}
            >
              Amount
            </Text>
          </View>

          {detailsInfo?.coasting_details?.map((item, index) => {
            if (index === 0) {
              return (
                <View style={styles.tableRow}>
                  <Text style={styles.tableCol1}>
                    Advanced Foot Care {"\n"}Service by Registered Practical
                    Nurse {detailsInfo?.provider_details?.provider_name}.,{" "}
                    {"\n"}Reg# {providerLicenseNo}
                  </Text>
                  <Text style={styles.tableCol2}>
                    ${detailsInfo?.coasting_details?.[0]?.amount}
                  </Text>
                </View>
              );
            } else {
              return (
                <View style={styles.tableRow} key={item.id}>
                  <Text style={styles.tableCol1}>{item.title}</Text>
                  <Text style={styles.tableCol2}>${item.amount}</Text>
                </View>
              );
            }
          })}
        </View>

        <View style={{ marginTop: 20 }}>
          <Text style={[styles.bold, { textAlign: "right", fontSize: "18px" }]}>
            Total: ${detailsInfo?.final_cost}
          </Text>
          <Text style={{ textAlign: "right", marginTop: "16px" }}>
            Payment on {formatToFullDate(detailsInfo?.booking_created_at)} using
            a reebuk wallet: ${detailsInfo?.final_cost}
          </Text>
          <Text
            style={[
              styles.bold,
              {
                textAlign: "right",
                fontSize: "18px",
                paddingTop: "20px",
                borderTop: "1px solid #000",
              },
            ]}
          >
            Amount Due: $0.00
          </Text>
        </View>

        <Text style={{ marginTop: 30 }}>
          CHEQUE TO BE MAILED TO OUR OFFICE ADDRESS GIVEN AT THE TOP RIGHT
          CORNER OF THE INVOICE.
        </Text>
      </Page>
    </Document>
  );
};

export default InvoicePDF;
